/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React, { useEffect, useRef } from "react"
import { Icon, Spacer, useMediaQuery } from "@cd2/components"
import Tippy from "@tippyjs/react"
import { icons } from "../utils/icons"
import { useGlobalState } from "../utils/globalState"
import { Flex } from "./Flex"
import { Link, useLocation } from "react-router-dom"
import { eRoutes } from "../routes"
import { Instance } from "tippy.js"

interface IProps {
  displayOnLightBackground?: boolean
  asIcon?: boolean
  disabled?: boolean
  containerRef?: React.RefObject<HTMLElement>
}
export function UserMenu({ disabled, containerRef }: IProps) {
  const ref = useRef<Instance | null>(null)
  const globalState = useGlobalState()
  const shortText = useMediaQuery({ maxWidth: 400 }, { ref: containerRef })
  const location = useLocation()

  useEffect(() => {
    ref.current?.hide()
  }, [location.pathname])

  return (
    <Tippy
      children={
        <div
          css={css`
            color: white;
            padding: 8px 12px;
            border-radius: 4px;
            margin: -8px 0;
            transition: 0.2s;
            cursor: pointer;
            :hover {
              background: rgba(0, 0, 0, 0.1);
            }
          `}
        >
          <Flex alignItems="center" gap={8}>
            <div
              css={css`
                width: 32px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: white;
                border-radius: 50%;
                color: black;
              `}
            >
              {globalState.user.name
                .split(" ")
                .map(part => part[0])
                .join("")}
            </div>
            {shortText ? "Me" : globalState.user.name}
            <Icon icon={icons.chevronDown} color="white" />
          </Flex>
        </div>
      }
      onCreate={ctx => (ref.current = ctx)}
      trigger={disabled ? "none" : "click"}
      placement="bottom-end"
      offset={[0, 0]}
      content={
        <div
          css={css`
            width: 150px;
            background: white;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
            text-align: left;

            a {
              display: block;
              padding: 16px 12px;
              color: #333333;
              text-decoration: none;
              :hover {
                text-decoration: underline;
              }
            }
          `}
        >
          {!globalState.user.isAdmin && !globalState.user.isEmployee && (
            <Link to={eRoutes["/profile"]}>
              <Icon icon={icons.settings} />
              <Spacer size={8} horizontal />
              Profile
            </Link>
          )}
          <Link to="/logout">
            <Icon icon={icons.logout} />
            <Spacer size={8} horizontal />
            Logout
          </Link>
        </div>
      }
      interactive
    />
  )
}
